import { useState }     from 'react';
import { Container }    from '@material-ui/core';
import { connect }      from 'react-redux';
import { toast }        from 'react-toastify';
// Redux
import {changeView}         from '../../redux/actions/Menu';
import {updateContacts}     from '../../redux/actions/Contacts';
// Components
import Input        from '../global/Input';
import ButtonsForm  from '../global/ButtonsForm';
import InputArea    from '../global/InputArea';
// Values
import {StateView, toastText}   from '../../values';
// Api
import {deleteData}             from '../../utils/contacts';

const Form = ({stateView, data, changeView, token, updateContacts}) => {
    const [blockData, setBlockData] = useState('disabled')
    // State buttons ----------------------------------------------------------------
    const [erase, setErase]         = useState(0)

    // Data -------------------------------------------------------------------------
    const [email, setEmail]         = useState(data.Email?data.Email:'')
    const [name, setName]           = useState(data.Name?data.Name:'')
    const [message, setMessage]     = useState(data.Message?data.Message:'')
    const [phone, setPhone]         = useState(data.Phone?data.Phone:'')
    const [subject, setSubject]     = useState(data.Subject?data.Subject:'')

    // Functions --------------------------------------------------------------------
    const Back = () =>{
        changeView(StateView.state1)
        updateContacts([])
    }

    const Delete = async() =>{
        const value = erase + 1
        setErase(value)
        if(value===1){
            const res = await deleteData(data.Id, token)
            if(res){
                toast.success(toastText.delete)
                console.log(toastText.delete)
                changeView(StateView.state1)
                updateContacts([])
            } else{
                toast.warn(toastText.warning)
                console.log(toastText.warning)
                setErase(0)
            }
        }
    }
    return (
        <Container maxWidth="xl">
            <div style={{background:'#fff', paddingBottom:50, paddingTop:20}}>
                <Container maxWidth="xl">
                    <div style={{display:'flex'}}>
                        <div style={{width:'48%'}}>
                            <Input title={'Nombre'} value={name} setData={setName} blockData={blockData} />
                            <Input title={'Correo'} value={email} setData={setEmail} type={'email'} blockData={blockData} />
                        </div>
                        <div style={{width:'4%'}} />
                        <div style={{width:'48%'}}>
                            <Input title={'Asunto'} value={subject} setData={setSubject} blockData={blockData} />
                            <Input title={'Teléfono'} value={phone} setData={setPhone} blockData={blockData} />
                        </div>
                    </div>
                    <InputArea title={'Mensaje'} value={message} setData={setMessage} blockData={blockData} />
                </Container>
            </div>
            <ButtonsForm View={stateView} Back={Back} edit={2} Delete={Delete} erase={erase} />
        </Container>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    data:           state.Contacts.contactsEdit,
    token:          state.Panel.token,
})
export default connect(mapStateToProps, {changeView, updateContacts})(Form);
